export class ToolbarCustom {
  constructor(quill) {
    this.quill = quill;
    this.toolbar = this.quill.getModule('toolbar');
    if (this.toolbar.options.toolbarCustom) {
      this.toolbar.addCustomHandler = (name, handler) => {
        this.addCustomHandler(name, handler);
      };
    }
  }

  addCustomHandler(name, handler) {
    const qlBtn = this.toolbar.container.querySelector(`.ql-${name}-btn`);
    qlBtn.addEventListener('click', handler, false);
  }
}

export { ToolbarCustom as default };
